import Helper from "./Helper";

class Tagmanager {
  constructor(config = {}) {
    const {
      tagSelector,
      allFilterSelector,
      removeFilterSelector,
      resultsSelector,
      openerTagSelector
    } = config;

    this.tags = document.querySelectorAll(tagSelector);
    this.allFilter = document.querySelector(allFilterSelector);
    this.removeFilter = document.querySelector(removeFilterSelector); 
    this.results = document.querySelector(resultsSelector); 

    this.openerTag = openerTagSelector;

    this.activeTags = [];

    this.bindEvents();
  }

  bindEvents(){
    this.tags.forEach(tag => {
      tag.addEventListener('click', e => {
        e.preventDefault();
        this.updateTags(tag);
      });
    });
    this.allFilter.addEventListener('click', e => {
      e.preventDefault();
      this.showAllLinks()
    });
    this.removeFilter.addEventListener('click', e => {
      e.preventDefault();
      this.removeAllLinks()
    });

    if(this.openerTag){
      if(document.querySelector('p[attr-hash="' + this.openerTag + '"]')){
        this.updateTags(document.querySelector('p[attr-hash="' + this.openerTag + '"]'));
      }
    }
  }


  updateTags(tag){
    let hash = tag.getAttribute('attr-hash');
    
    if(this.activeTags.includes(hash)) {
      tag.classList.remove("active");
      this.activeTags = this.activeTags.filter(e => e !== hash);
    
    } else {
      tag.classList.add("active");
      if(this.activeTags.length == 2) {
        document.querySelector('p[attr-hash="' + this.activeTags.shift() + '"]').classList.remove("active");
      }
      this.activeTags.push(hash)

    }
    
    this.updateLinks();
  }

  updateLinks(){
    if(tagmag_json){
      this.results.innerHTML = "";
      
      for (let key in tagmag_json['tagmag']){
        if(tagmag_json['tagmag'][key]['field'] != ''){

          let url = tagmag_json['tagmag'][key]['url'];
          let title = tagmag_json['tagmag'][key]['title'];
          let field =  tagmag_json['tagmag'][key]['field'];

          if(this.activeTags.length == 2){
            if(field.search(this.activeTags[0]) !== -1 || field.search(this.activeTags[1]) != -1){
              this.results.innerHTML += this.getLink(url, title);
            }

          } else if(this.activeTags.length == 1) {
            if(field.search(this.activeTags[0]) !== -1){
              this.results.innerHTML += this.getLink(url, title);
            }

          } else {
            this.removeAllLinks();
          }
        }
      }
      
      this.sortResults();
    }
  }

  removeActive(){
    this.tags.forEach(tag => {
      tag.classList.remove('active');
    });
  }

  showAllLinks(){
    this.activeTags = [];

    if(tagmag_json){
      this.results.innerHTML = "";
      for (let key in tagmag_json['tagmag']){
        if(tagmag_json['tagmag'][key]['field'] != ''){
          let url = tagmag_json['tagmag'][key]['url'];
          let title = tagmag_json['tagmag'][key]['title'];
          this.results.innerHTML += this.getLink(url, title);
        }
      }

      this.sortResults();
      this.removeActive();
    }
  }

  sortResults(){
    Array.from(this.results.getElementsByTagName("a"))
    .sort((a, b) => a.textContent.localeCompare(b.textContent))
    .forEach(li => this.results.appendChild(li));
  }

  getLink(url, title){
    return `<a href="${url}" class="ns-result">${title}</a>`;
  }


  removeAllLinks(){
    this.activeTags = [];
    this.removeActive();
    this.results.innerHTML = `<p class="ns-no-result">Keine Filter ausgewählt</p>`;
  };
}
export default Tagmanager;